import {useState} from 'react';

// material-ui
import {List, ListItemButton, ListItemIcon, ListItemText} from '@mui/material';
// assets
import {KeyOutlined, LogoutOutlined, UserOutlined} from '@ant-design/icons';
import {EmployeeType} from 'modules/hr/employee/types/EmployeeType';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

interface Props {
    handleLogout: () => void;
    user: EmployeeType;
}

const ProfileTab = ({handleLogout, user}: Props) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const handleListItemClick = (event: React.MouseEvent<HTMLDivElement>, index: number) => {
        setSelectedIndex(index);
        if (index == 1) {
            window.location.href = '/app/profile/' + user?.account_no;
        } else if (index == 2) {

            window.location.href = '/app/change-password';
        }
    };

    return (
        <List component="nav" sx={ {p: 0, '& .MuiListItemIcon-root': {minWidth: 32}} }>
            {/* <ListItemButton selected={selectedIndex === 0} onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 0)}>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary="Edit Profile" />
      </ListItemButton> */ }
            <ListItemButton selected={ selectedIndex === 1 }
                            onClick={ (event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 1) }>
                <ListItemIcon>
                    <UserOutlined/>
                </ListItemIcon>
                <ListItemText primary="View Profile"/>
            </ListItemButton>

            {/* <ListItemButton selected={selectedIndex === 3} onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 3)}>
        <ListItemIcon>
          <ProfileOutlined />
        </ListItemIcon>
        <ListItemText primary="Social Profile" />
      </ListItemButton>
      <ListItemButton selected={selectedIndex === 4} onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 4)}>
        <ListItemIcon>
          <WalletOutlined />
        </ListItemIcon>
        <ListItemText primary="Billing" />
      </ListItemButton> */ }

            <ListItemButton selected={ selectedIndex === 2 }
                            onClick={ (event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 2) }>
                <ListItemIcon>
                    <KeyOutlined/>
                </ListItemIcon>
                <ListItemText primary="Change Password"/>
            </ListItemButton>
            <ListItemButton onClick={ handleLogout }>
                <ListItemIcon>
                    <LogoutOutlined/>
                </ListItemIcon>
                <ListItemText primary="Logout"/>
            </ListItemButton>
        </List>
    );
};

export default ProfileTab;
